import React from 'react'
import { PageHeader, Row, Col, Card } from 'antd'

// import all the styles
import 'code-highlight/lib/style.css'
import 'highlight.js/styles/github-gist.css'

const routes = [
  {
    path: '/',
    breadcrumbName: 'Base',
  },
  {
    path: 'Typography',
    breadcrumbName: 'Typography',
  },
]

const Typography = () => {
  return (
    <>
      <PageHeader title="Typography" breadcrumb={{ routes }} style={{ padding: 10 }}/>

      <Row gutter={20}>
        <Col span={12}>
          <Card title="Heading Tag">
            <h1>heading1</h1>
            <h2>heading2</h2>
            <h3>heading3</h3>
            <h4>heading4</h4>
            <h5>heading5</h5>
            <h6>heading6</h6>
          </Card>
        </Col>
        <Col span={12}>
          <Card title="Card title">
            <div className="dp_4">아이템매니아 72</div>
            <div className="dp_3">아이템매니아 52</div>
            <div className="dp_2">아이템매니아 40</div>
            <div className="dp_1">아이템매니아 34</div>
          </Card>
        </Col>
      </Row>


    </>
  )
}

export default Typography
